module.exports = __webpack_public_path__ + "img/I58A5054@2x.0eafed3f.png";